import { render, staticRenderFns } from "./NationalHolidayDetail.vue?vue&type=template&id=1dbdb3b8&"
import script from "./NationalHolidayDetail.vue?vue&type=script&lang=ts&"
export * from "./NationalHolidayDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports